@if (documentDestinationOptionsAllowed) {
  @for (destinationType of destinationsForOutputFileType; track destinationType.type) {
    <td class="no-padding">
      <app-output-file-type-section
        [formGroup]="outputFileTypeSectionFormGroup"
        [workflowConfigNamespace]="namespace"
        [destination]="destinationType"
        [multiple]="destinationsForOutputFileType.length > 1"
        [entityType]="entityType"
        [forSignature]="forSignature"
        (updateDocumentForDestinationType)="updateDocumentForDestinationType.emit($event)"
      >
      </app-output-file-type-section>
    </td>
  }
} @else {
  @if (fileTypeOptionsAllowed) {
    <td class="no-padding">
      <app-output-file-type-section
        [formGroup]="outputFileTypeSectionFormGroup"
        [workflowConfigNamespace]="namespace"
        [entityType]="entityType"
        [forSignature]="forSignature"
        (updateDocumentForDestinationType)="updateDocumentForDestinationType.emit($event)"
      ></app-output-file-type-section>
    </td>
  }
}
